// extracted by mini-css-extract-plugin
export default {"container":"ContactInfo_container__-8b1q","list":"ContactInfo_list__GbEPH","icon":"ContactInfo_icon__2g0ul","muted":"ContactInfo_muted__gAROc"};